var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVideo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 33,
  viewBox: "0 0 32 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    verticalAlign: "middle"
  }
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.6665 9.5708C1.6665 9.01852 2.11422 8.5708 2.6665 8.5708H17.3332C19.3582 8.5708 20.9998 10.2124 20.9998 12.2375V24.2375C20.9998 24.7898 20.5521 25.2375 19.9998 25.2375H5.33317C3.30813 25.2375 1.6665 23.5958 1.6665 21.5708V9.5708ZM3.6665 10.5708V21.5708C3.6665 22.4913 4.4127 23.2375 5.33317 23.2375H18.9998V12.2375C18.9998 11.317 18.2536 10.5708 17.3332 10.5708H3.6665Z",
  fill: "#F38401"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.6662 11.3905C27.9383 11.2783 28.2315 11.2284 28.5207 11.2388C28.8101 11.2493 29.1003 11.3205 29.3648 11.4548C29.6293 11.5892 29.8709 11.7887 30.0488 12.0514C30.2282 12.3162 30.3333 12.6325 30.3332 12.9683V20.8396C30.3332 21.1754 30.228 21.4917 30.0486 21.7565C29.8708 22.0189 29.6295 22.2183 29.3653 22.3528C29.1011 22.4872 28.8111 22.5585 28.522 22.5693C28.2328 22.5802 27.9395 22.5306 27.6673 22.4188L23.6195 20.7543C23.1087 20.5443 22.8649 19.9599 23.075 19.4491C23.285 18.9384 23.8694 18.6946 24.3801 18.9046L28.3332 20.5301V13.2787L24.3801 14.9043C23.8694 15.1143 23.285 14.8705 23.075 14.3597C22.8649 13.8489 23.1087 13.2646 23.6195 13.0546L27.6662 11.3905Z",
  fill: "#F38401"
})));
export default SvgVideo;